
import { Options, Vue } from 'vue-class-component';
import ModalBox from '@/shared/components/modal-box/index.vue';
import { Inject, Prop } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from 'events';
import store from '../../../store';
import { AccountingAppRequest, AccountingAppView, Status } from '@/shared/modules/typescript-trustapi-client/models';

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
  }
})
export default class AddEditAccountingSoftwareModal extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'statusType', default: [] })
  private statusType!: Status[];

  @Prop({ default: {}})
  private accountingApp!: AccountingAppView;
  private formData: AccountingAppView = {};

  private status = 1;
  private isShowInAtcs = false; // Default is No
  private certified = null;
  private submitting = false;
  private loadingContent = false;
  private errorLoadingContent = false;
  private showCancelAlert = false;



  created(): void {
    this.formData = JSON.parse(JSON.stringify(this.accountingApp));
  
    if (this.editMode) {
      this.status = this.formData.status.id;
      this.certified = this.formData.certifiedType.id;
      this.isShowInAtcs = this.formData.isShowInAtcs;
    } else {
      this.formData.status = {
        id: 1
      }
      this.formData.certifiedType = {
        id: null
      }
    }

  }

  private async saveAccountingSoftware(): Promise<void> {
    try {
      if (!this.validForm && !this.isFormDirty) {
        throw new Error('Invalid Data Filled');
      }  
      this.submitting = true;
      this.formData.status = {
        id: this.status
      }
      this.formData.isShowInAtcs = this.isShowInAtcs;
      this.formData.certifiedType = {
        id: this.certified
      }
      const appReq: AccountingAppRequest = {
        id: this.formData.id,
        name: this.formData.name,
        description: this.formData.name,
        statusId: this.formData.status?.id,
        isShowInAtcs: this.formData.isShowInAtcs,
        certifiedTypeId: this.formData.certifiedType?.id,
      };

      await this.apiService.AccountingAppApi?.apiV2AccountingAppSaveAccountingAppPost(appReq);
      this.eventCtrl.emit('reload-accounting-software');

      if (appReq.id == 0) {
        this.eventCtrl.emit('show-snackbar', 'success', 'Added Successfully');
      } else {
        this.eventCtrl.emit('show-snackbar', 'success', 'Updated Successfully');
      }
      this.closeModal();
    } catch(err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Unable to process request');
    } finally {
      this.submitting = false;
    }
  }

  
  get validForm(): boolean {
    try {
      return this.formData.name.trim() &&
      this.formData.name.trim().length <= 200 &&
      this.status && this.certified;
    } catch {
      return false;
    }
  }

  get isFormDirty(): boolean {
    if (this.editMode) {
      const modifiedAppName = this.accountingApp.name !== this.formData.name;
      const modifiedStatus = this.accountingApp.status.id !== this.status;
      const modifiedCertified = this.accountingApp.certifiedType.id !== this.certified;
      const modifiedIsShowInAtcs = this.accountingApp.isShowInAtcs !== this.isShowInAtcs;
      return modifiedAppName || modifiedStatus || modifiedCertified || modifiedIsShowInAtcs;
    } else {
      return !!this.formData.name && this.formData.name.length > 0;
    }
  }

  private closeModal() {
    this.$emit('closeAddEditAccountingSoftwareModal');
  }

  get editMode(): boolean {
    return this.accountingApp?.id > 0;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

}

